// WelcomePopup — shown once (after profile completion or on first hub visit for returning users)
// 4 actions: Start Playing · Take a Tour · Pick a Theme · Customize Avatar.

import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { PlayCircle, Compass, Palette, Camera, X } from "lucide-react";

export default function WelcomePopup({ open, onClose, onAction, displayName, funTitle }) {
  const greet = displayName ? displayName.split(" ")[0] : "Hero";

  const buttons = [
    { key: "play",   icon: PlayCircle, label: "Start Playing 🎮", desc: "Jump into today's games right now.",       primary: true },
    { key: "tour",   icon: Compass,    label: "Take a Tour",       desc: "5-step walkthrough of the Fun Zone." },
    { key: "theme",  icon: Palette,    label: "Pick a Theme",      desc: "Reskin everything to your hero." },
    { key: "avatar", icon: Camera,     label: "Customize Avatar",  desc: "Upload your face / pet / mood." },
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-4 border-black rounded-none brutal-shadow max-w-xl bg-[#FDFBF7]" data-testid="welcome-popup">
        <DialogHeader>
          <DialogTitle className="text-2xl sm:text-3xl font-black uppercase flex items-center gap-3">
            <img src="/brand/tekwissen-logo.png" alt="" width={40} height={40} className="rounded-full border-2 border-black bg-white"/>
            <span>
              Welcome aboard, <span className="text-[#39FF14]" style={{ WebkitTextStroke: "1px black" }}>{greet}</span>!
            </span>
          </DialogTitle>
        </DialogHeader>
        {funTitle && (
          <div className="border-2 border-black bg-[#FFD600] inline-block px-3 py-1 brutal-shadow-sm self-start text-sm font-black uppercase">
            🎖 {funTitle}
          </div>
        )}
        <p className="text-sm text-neutral-700">
          You're officially in. Pick your first move below — you can always come back to the others.
        </p>
        <div className="grid sm:grid-cols-2 gap-3">
          {buttons.map((b) => (
            <button
              key={b.key}
              data-testid={`welcome-action-${b.key}`}
              onClick={() => onAction(b.key)}
              className={`text-left p-4 border-2 border-black transition-all hover:translate-y-[-2px] ${b.primary ? "bg-[#39FF14] brutal-shadow-sm hover:brutal-shadow" : "bg-white hover:brutal-shadow-sm"}`}
            >
              <div className="flex items-center gap-2 font-black uppercase text-sm">
                <b.icon size={16}/> {b.label}
              </div>
              <div className="text-xs text-neutral-700 mt-1">{b.desc}</div>
            </button>
          ))}
        </div>
        <button
          data-testid="welcome-dismiss"
          onClick={onClose}
          className="text-xs text-neutral-500 hover:text-black underline self-end mt-2 inline-flex items-center gap-1"
        >
          <X size={12}/> Maybe later
        </button>
      </DialogContent>
    </Dialog>
  );
}
